<template>
  <div>
    <ul class="hidden-xs-only">
      <li v-for="item in markedSections" :key="item.name">
        <a :href="`#${item.name}`"
          ><span
            :class="{
              reverse: item.reverse,
              active: item.active,
            }"
          ></span
        ></a>
      </li>
    </ul>
    <ul class="hidden-sm-and-up">
      <li v-for="item in mobileMarkedSections" :key="item.name">
        <a :href="`#${item.name}`"
          ><span
            :class="{
              reverse: item.reverse,
              active: item.active,
            }"
          ></span
        ></a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      sections: ['home', 'vision', 'products', 'team', 'values', 'careers'],
      reverseList: ['home', 'vision', 'products'],
      mobileReverseList: ['home', 'products'],
    };
  },
  computed: {
    ...mapGetters(['currentSection']),
    markedSections() {
      return this.sections.map(section => ({
        name: section,
        active: this.currentSection === section,
        reverse: this.reverseList.includes(this.currentSection),
      }));
    },
    mobileMarkedSections() {
      return this.sections.map(section => ({
        name: section,
        active: this.currentSection === section,
        reverse: this.mobileReverseList.includes(this.currentSection),
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
ul {
  z-index: 100;
  position: absolute;
  top: 25%;
  right: 2%;
  list-style-type: none;
  margin: 0;
  padding: 0;
  transform: translateY(-50%);
  @media (min-width: $sm) {
    top: 50%;
  }
  li {
    a {
      transform: translate(-50%, -50%);
      display: flex;
      justify-content: center;
      align-items: center;
      width: 1rem;
      height: 1rem;
      cursor: pointer;
      margin-bottom: 0.5rem;
      @media (min-width: $sm) {
        margin-bottom: 1rem;
      }
      span {
        display: block;
        background: $color-primary;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        transition: all 0.3s ease;
        opacity: 0.6;

        &.active {
          width: 12px;
          height: 12px;
          border-radius: 6px;
          opacity: 1;
        }
        &.reverse {
          opacity: 0.3;
          background: $color-white;
          &.active {
            opacity: 1;
          }
        }
      }
      &:hover {
        span {
          width: 12px;
          height: 12px;
          border-radius: 6px;
          opacity: 1;
        }
      }
    }
  }
}
</style>
